import {
  body,
  off,
} from './style'
import { DeviceButtonTypes } from "types"
import { Icon } from 'icons/Icon'

export const CameraButton = ({onClick, on}: DeviceButtonTypes) => {
  return (
    <div className={`${body} ${on ? '' : off}`} onClick={() => onClick()}>
      {on && <Icon name="CameraOn" size={22} />}
      {!on && <Icon name="CameraOff" size={22} />}
    </div>
  );
}

